import { Navigate, useParams } from 'react-router-dom';

const RedirectToPrivacy: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  return <Navigate to={`/${lang || 'fr'}/privacy`} replace />;
};

export default RedirectToPrivacy;
